import {ComponentChild, h} from 'preact'
import Panel from '../panel'

const CommunityFooter = ({ switcher }: {switcher: ComponentChild}) => {
  return (
    <Panel
      class='homepage-widget'
      title={
        <div className='panel-title-with-switch'>
          Footer
          { switcher }
        </div>
      } />
  )
}

export default CommunityFooter
